import { CacheOperation } from '@enums/cache-operation.enum';
import { CachingPrefix } from '@enums/caching-prefix.enum';
import { useReactQueryCaching } from '@hooks/use-react-query-caching';
import { Modal } from '@testsigma/atoms';
import { Upload } from '@testsigmainc/models';
import { Form } from './upload-form';

interface UploadFormProps {
  show: boolean;
  upload?: Upload;
  onClose: () => void;
  onSuccess: () => void;
  applicationVersionId?: number;
  applicationId?: number;
  isStrictMode?: boolean;
  isForceUpload?: boolean;
}

export const UploadFormModal: React.FC<UploadFormProps> = ({
  show,
  upload = new Upload(),
  onSuccess,
  onClose,
  applicationVersionId,
  applicationId,
  isStrictMode = false,
  isForceUpload = false,
}) => {
  const { cacheOperationHandler } = useReactQueryCaching(
    CachingPrefix.FETCH_TESTDATA_UPLOADS,
    false,
  );
  return (
    <Modal
      isOpen={show}
      className={'!rounded-xl !p-0'}
      closeOnEscape={false}
      closeOnOutsideClick={false}
      zIndex={5000}
    >
      <Form
        upload={upload}
        onClose={onClose}
        onSuccess={() => {
          cacheOperationHandler(CacheOperation.REMOVE_CACHE);
          onSuccess();
        }}
        applicationVersionId={applicationVersionId}
        applicationId={applicationId}
        isStrictMode={isStrictMode}
        isForceUpload={isForceUpload}
      />
    </Modal>
  );
};
